import { Component, effect, inject, Injector, input, model, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormulasComponent } from '@module-definition/formulas/cipo-formula/formula-wizard.component';
import { FormulaField } from '@module-definition/formulas/cipo-formula/formula.model';
import { CipoFormModule } from '@shared/modules/forms.module';
import { UserService } from '@shared/services';

export type JsonLogic = { [operator: string]: JsonLogicPropertyValue[] };

export type JsonLogicPropertyValue = string | number | boolean | JsonLogicVariable | JsonLogic;

export type JsonLogicVariable = { var: string | number | boolean };

@Component({
  selector: 'cipo-formula-definition',
  templateUrl: './cipo-formula-definition.component.html',
  styleUrls: ['./cipo-formula-definition.component.scss'],
  imports: [CipoFormModule],
})
export class FormulaDefinitionComponent {
  dialog = inject(MatDialog);
  userService = inject(UserService);
  injector = inject(Injector);

  formula = model<JsonLogic | null>(null);
  fields = input<FormulaField[]>([]);

  currentFormula = signal<JsonLogic>(null);

  constructor() {
    effect(() => {
      this.currentFormula.set(this.formula());
    });
  }

  onFormulaInput(event: Event) {
    const target = event.target as HTMLInputElement;
    const value = target.value;
    if (!value.trim()) {
      this.currentFormula.set(null);
      return;
    }
    try {
      const parsed = JSON.parse(value);
      this.currentFormula.set(parsed);
    } catch {
      this.currentFormula.set(null);
    }
  }

  openFormulaHelper() {
    this.dialog
      .open(FormulasComponent, {
        autoFocus: false,
        panelClass: ['cipo-dialog', 'classic', 'cipo--height--full'],
        data: {
          initialFormula: this.currentFormula(),
          fields: this.fields(),
        },
        injector: this.injector,
        ...this.userService.getResponsiveDialogSize().lg,
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.currentFormula.set(result);
        }
      });
  }
}

